/*eslint-disable*/
// @mui material components 
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";

// Images
import bgImage from "assets/images/shapes/waves-white.svg";

function Download() {
  return (
    <MKBox component="section" py={{ xs: 0, sm: 12 }}>
      <MKBox
        variant="gradient"
        bgColor="dark"
        position="relative"
        borderRadius="xl"
        sx={{ overflow: "hidden" }}
      >
        <MKBox
          component="img"
          src={bgImage}
          alt="pattern-lines"
          position="absolute"
          top={0}
          left={0}
          width="100%"
          zIndex={1}
          opacity={0.2}
        />
        <Container sx={{ position: "relative", zIndex: 2, py: 12 }}>
          <Grid container item xs={12} md={7} justifyContent="center" mx="auto" textAlign="center">
            <MKTypography variant="h3" color="white">
              Mes technologies et outils clés
            </MKTypography>
            <MKTypography variant="body2" color="white" mb={6}>
              Découvrez les technologies, logiciels et frameworks que je maîtrise pour le développement logiciel, le SIG, le design et la gestion de projets numériques.
            </MKTypography>
          </Grid>

        </Container>
      </MKBox>
      <Container>
        <Grid container item xs={12} mx="auto">
          <MKBox textAlign="center" sx={{ overflowX: "auto", whiteSpace: "nowrap", py: 2 }}>
            <Grid container spacing={3} sx={{ display: "inline-flex", flexWrap: "nowrap" }}>
              {/* React */}
              <Grid item xs={4} lg={2}>
                <Tooltip title="React">
                  <MKBox>
                    <MKBox
                      component="img"
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg"
                      width={75}
                    />
                  </MKBox>
                </Tooltip>
              </Grid>

              {/* Node.js */}
              <Grid item xs={4} lg={2}>
                <Tooltip title="Node.js">
                  <MKBox>
                    <MKBox
                      component="img"
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original.svg"
                      width={75}
                    />
                  </MKBox>
                </Tooltip>
              </Grid>

              {/* Vue.js */}
              <Grid item xs={4} lg={2}>
                <Tooltip title="Vue.js">
                  <MKBox>
                    <MKBox
                      component="img"
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/vuejs/vuejs-original.svg"
                      width={75}
                    />
                  </MKBox>
                </Tooltip>
              </Grid>

              {/* Angular */}
              <Grid item xs={4} lg={2}>
                <Tooltip title="Angular">
                  <MKBox>
                    <MKBox
                      component="img"
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/angularjs/angularjs-original.svg"
                      width={75}
                    />
                  </MKBox>
                </Tooltip>
              </Grid>

              {/* CodeIgniter */}
              <Grid item xs={4} lg={2}>
                <Tooltip title="CodeIgniter">
                  <MKBox>
                    <MKBox
                      component="img"
                      src="https://cdn6.aptoide.com/imgs/b/7/3/b73992e63828958839d4289b55fbfd72_icon.png"
                      width={75}
                    />
                  </MKBox>
                </Tooltip>
              </Grid>

              {/* Symfony */}
              <Grid item xs={4} lg={2}>
                <Tooltip title="Symfony">
                  <MKBox>
                    <MKBox
                      component="img"
                      src="https://assets.axopen.com/assets/uploads/logo_symfony_dc0a43bec8.png"
                      width={75}
                    />
                  </MKBox>
                </Tooltip>
              </Grid>

              {/* Laravel */}
              <Grid item xs={4} lg={2}>
                <Tooltip title="Laravel">
                  <MKBox>
                    <MKBox
                      component="img"
                      src="https://upload.wikimedia.org/wikipedia/commons/9/9a/Laravel.svg"
                      width={75}
                    />
                  </MKBox>
                </Tooltip>
              </Grid>
                  {/* Wordpress */}
                  <Grid item xs={4} lg={2}>
                <Tooltip title="Wordpress">
                  <MKBox>
                    <MKBox
                      component="img"
                      src="https://s.w.org/style/images/about/WordPress-logotype-wmark.png"
                      width={75}
                    />
                  </MKBox>
                </Tooltip>
              </Grid>

              {/* PHP */}
              <Grid item xs={4} lg={2}>
                <Tooltip title="PHP">
                  <MKBox>
                    <MKBox
                      component="img"
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/php/php-original.svg"
                      width={75}
                    />
                  </MKBox>
                </Tooltip>
              </Grid>

              {/* Java */}
              <Grid item xs={4} lg={2}>
                <Tooltip title="Java">
                  <MKBox>
                    <MKBox
                      component="img"
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg"
                      width={75}
                    />
                  </MKBox>
                </Tooltip>
              </Grid>

              {/* Python */}
              <Grid item xs={4} lg={2}>
                <Tooltip title="Python">
                  <MKBox>
                    <MKBox
                      component="img"
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg"
                      width={75}
                    />
                  </MKBox>
                </Tooltip>
              </Grid>

              {/* MongoDB */}
              <Grid item xs={4} lg={2}>
                <Tooltip title="MongoDB">
                  <MKBox>
                    <MKBox
                      component="img"
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original.svg"
                      width={75}
                    />
                  </MKBox>
                </Tooltip>
              </Grid>

              {/* PostgreSQL */}
              <Grid item xs={4} lg={2}>
                <Tooltip title="PostgreSQL">
                  <MKBox>
                    <MKBox
                      component="img"
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/postgresql/postgresql-original.svg"
                      width={75}
                    />
                  </MKBox>
                </Tooltip>
              </Grid>

              {/* MySQL */}
              <Grid item xs={4} lg={2}>
                <Tooltip title="MySQL">
                  <MKBox>
                    <MKBox
                      component="img"
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original.svg"
                      width={75}
                    />
                  </MKBox>
                </Tooltip>
              </Grid>

              {/* Photoshop */}
              <Grid item xs={4} lg={2}>
                <Tooltip title="Photoshop">
                  <MKBox>
                    <MKBox
                      component="img"
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/photoshop/photoshop-plain.svg"
                      width={75}
                    />
                  </MKBox>
                </Tooltip>
              </Grid>

              {/* Illustrator */}
              <Grid item xs={4} lg={2}>
                <Tooltip title="Illustrator">
                  <MKBox>
                    <MKBox
                      component="img"
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/illustrator/illustrator-plain.svg"
                      width={75}
                    />
                  </MKBox>
                </Tooltip>
              </Grid>
              {/* InDesign */}
              <Grid item xs={4} lg={2}>
                <Tooltip title="InDesign">
                  <MKBox>
                    <MKBox
                      component="img"
                      src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQlD6gMFT3LZ1ykymiSmeGfYT6pLpwiwYHLTw&s"
                      width={75}
                    />
                  </MKBox>
                </Tooltip>
              </Grid>
              {/* Figma */}
              <Grid item xs={4} lg={2}>
                <Tooltip title="Figma">
                  <MKBox>
                    <MKBox
                      component="img"
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/figma/figma-original.svg"
                      width={75}
                    />
                  </MKBox>
                </Tooltip>
              </Grid>



              {/* QGIS */}
              <Grid item xs={4} lg={2}>
                <Tooltip title="QGIS">
                  <MKBox>
                    <MKBox
                      component="img"
                      src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRlkUTm7AgJweKjBBJIOIayiXnMxIwnP-UXeA&s"
                      width={75}
                    />
                  </MKBox>
                </Tooltip>
              </Grid>

              {/* ArcGIS */}
              <Grid item xs={4} lg={2}>
                <Tooltip title="ArcGIS">
                  <MKBox>
                    <MKBox
                      component="img"
                      src="https://www.esri.com/content/dam/esrisites/en-us/common/logos/arcgis-logo-dark.png"
                      width={75}
                    />
                  </MKBox>
                </Tooltip>
              </Grid>
            </Grid>


          </MKBox>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Download;
